new Vue({
    el: '.support',
    data() {
        return {
            code: '',
            verifyClick: false,
            popup: false,
            times: '',
            firstTime: '',
            infoErr: '',
            type: 0,
            loadFlag: false,
            navIndex:0,
            navData:[
                {
                    img:'https://cdn.shopify.com/s/files/1/0930/5397/6894/files/31e34bca9a5dfd6b3cae6105f03422ab.svg?v=1785135820',
                    text:'VERIFY'
                },
                {
                    img:'https://cdn.shopify.com/s/files/1/0930/5397/6894/files/d8a89963aa468415a5b3b598826f7653.svg?v=1785135820',
                    text:'FAQ'
                },
                {
                    img:'https://cdn.shopify.com/s/files/1/0930/5397/6894/files/72c09d4a60bd2b28242cc744954c533e.svg?v=1785135820',
                    text:'CONTACT'
                },
                {
                    img:'https://cdn.shopify.com/s/files/1/0930/5397/6894/files/e111f6b684a3199ade88ce16fc7ad28d.svg?v=1785135820',
                    text:'PARTNER'
                },
                {
                    img:'https://cdn.shopify.com/s/files/1/0930/5397/6894/files/f4e522fb1b145bd21cbd6197b509097f.svg?v=1785135820',
                    text:'COMPLIANT'
                }
            ],
            faqNavIndex:0,
            faqNavData:['Business Inquiry','Product Inquiry']
        }
    },
    methods: {
        hoverNav(index) {
            const navList = this.$el.querySelectorAll('.b2_nav');
            const target = navList[index];
    
            if (target) {
                target.dispatchEvent(new PointerEvent('pointerenter', {
                    bubbles: false
                }));
            }
        },
        chanceNav(index){
            if(index<4){
                this.navIndex = index
                var element = document.querySelector(".box2_nav");
                element.scrollIntoView({block: "start",behavior: "smooth"});
            }else{
                window.open('https://cdn.shopify.com/s/files/1/0930/5397/6894/files/FDA_and_State_Status_of_Nixodine_Vapor_Products_-_Short_Form_August_2025.pdf?v=1782790899')
            }
        },
        async verifyCode() {
            if (this.verifyClick) { return }
            if (this.code == '') {
                showMessage('The Security code cannot be empty', 'error')
                return
            }
            //是否为16位
            if (this.code.length != 16) {
                showMessage('The security code must be 16 digits', 'error')
                return
            }

            this.verifyClick = true
            showMessage('Verifying, please wait...', 'success')
            let res = await axios.post(`https://ckglobal.fw-12365.com/ashx/SecurityQueryApi.ashx?Key=tc201805051108&FWCode=${this.code}&Lang=en-gb`)
            //-1:频繁验证 0:错误码 1:首次验证 2:验证两次及以上 4:IP频繁变换异常提醒
            if (res.status == 200) {
                this.verifyClick = false
                if (res.data.State == -1) {
                    //短时间频繁验证或其它行为
                    this.infoErr = 'The security code <span>(' + this.code + ')</span> verification is frequent, please try again later.'
                } else if (res.data.State == 0) {
                    //验证码错误
                    this.infoErr = 'The security code <span>(' + this.code + ')</span> you searched does not exist!'
                }
                this.type = res.data.State
                this.times = res.data.Times
                this.firstTime = (res.data.FirstDate).replace('T', '  ')
                this.popup = true
            }else{
                this.verifyClick = false
                showMessage('Server error, please contact customer service', 'error')
            }
        }
    },
    created() {
        // 加载完成后 更新弹窗显示样式
        this.loadFlag = true
        //扫码验证
        let url = new URL(window.location.href);
        let id = url.searchParams.get('id');
        let code = url.searchParams.get('code');

        if (code) {
            this.code = code;
            setTimeout(() => {
                $('.age_verify').css('display', 'none');
                $('html').css('overflow','visible');
                this.verifyCode();
            }, 500);
        }

        if (id !== null && Number(id) < 4) {
            // let element = document.querySelector(".box2_nav");
            // if(element){
            //     element.scrollIntoView({ block: "start", behavior: "smooth" });
            // }
            this.navIndex = Number(id);
        }
    },
    mounted(){

        $('.fr_text span').each(function(index) {
            const style = document.createElement('style');
            style.innerHTML = `.fr_text span:nth-child(${index + 1})::before { content: '${index + 1}.'; }`;
            document.head.appendChild(style);
        });
        
        $('.fr_title').click(function() {
            var $currentText = $(this).next('.fr_text');
            var Toheight = $currentText[0].scrollHeight;
            var heightFlag = $currentText.css('height');
        
            // 如果当前是关闭状态，执行展开操作
            if (heightFlag == '0px') {
                // 收起所有其他项
                $('.fr_text').css({ height: '0' });
                $('.fri_line').removeClass('fri_active');
        
                // 展开当前项
                $(this).children('.fri_right').children('.fri_line').addClass('fri_active');
                $currentText.css({ height: `${Toheight}px` });
            } else {
                // 当前已展开，执行关闭操作
                $(this).children('.fri_right').children('.fri_line').removeClass('fri_active');
                $currentText.css({ height: '0' });
            }
        });
        
        $('.ct_item').hover(function(){
            $(this).find('div:last-child').children('a').addClass('shakeX')
        },function(){
            $(this).find('div:last-child').children('a').removeClass('shakeX')
        })
    }
})